import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import {PrimePetalLongModule} from 'src/app/ui/shared/modules/prime-petal-long/prime-petal-long.module';
import {ProductImageModule} from '../product-image/product-image.module';
import {ProductQuantityControlsModule} from '../product-quantity-controls/product-quantity-controls.module';
import {ButtonModule} from '../button/button.module';
import {MultiCountryCurrencyModule} from '../../pipes/multi-country-currency/multi-country-currency.module';
import {ProductPetalModule} from '../product-petal/product-petal.module';
import {FavoritesButtonModule} from '../favorites-button/favorites-button.module';
import {BolivarDigitalButtonModule} from '../bolivar-digital-button/bolivar-digital.module';
import {NewProductCardComponent} from './new-product-card.component';
import {FlashOfferModule} from '../flash-offer/flash-offer.module';
import {ProductCardGroupModule} from '../product-card-group/product-card-group.module';
import {SuggestCardModule} from '../suggest-card/suggest-card.module';
import {VtoPlayerModule} from '../vto-player/vto-player.module';

@NgModule({
  declarations: [NewProductCardComponent],
  exports: [NewProductCardComponent],
  imports: [
    CommonModule,
    RouterModule,
    MultiCountryCurrencyModule,
    ProductImageModule,
    ProductPetalModule,
    ProductQuantityControlsModule,
    ButtonModule,
    FavoritesButtonModule,
    BolivarDigitalButtonModule,
    PrimePetalLongModule,
    FlashOfferModule,
    ProductCardGroupModule,
    SuggestCardModule,
    VtoPlayerModule,
  ],
})
export class NewProductCardModule {}
